<template>
    <div>
        <template v-if="isCreation && !forceType">
            <div class="mb-4">
                <b-form-radio-group
                    class="cursus-radios"
                    v-model="account.is_organization"
                    stacked
                    name="is_organization"
                >
                    <OrganizationAccountTypeRadio class="mb-2" :value="true" />
                    <PersonalAccountTypeRadio :value="false" />
                </b-form-radio-group>

                <template v-if="!hasSelectedAccountType">
                    <div class="mt-4" :class="{ 'text-right': !inline }">
                        <button class="btn btn-primary btn-lg" @click="hasSelectedAccountType = true">
                            Continuer&nbsp;&nbsp;&gt;
                        </button>
                    </div>
                </template>
            </div>
        </template>

        <template v-if="hasSelectedAccountType">
            <form @submit="handleSubmitted" v-bind="$attrs">
                <template v-if="hasErrors">
                    <div class="alert alert-danger">
                        Il y a une ou plusieurs erreurs dans le formulaire.
                    </div>
                </template>

                <input type="hidden" name="is_organization" :value="account.is_organization ? '1' : '0'">

                <fieldset class="mb-4" :key="account.is_organization ? 'organization' : 'personal'">

                    <legend class="mb-3">Vos informations</legend>

                    <template v-if="user">
                        <div class="mb-4">
                            <div>{{ user.full_name }}</div>
                            <div>{{ user.email }}</div>
                        </div>
                    </template>

                    <template v-if="account.is_organization">
                        <Field
                            name="organization_name"
                            v-model="account.organization_name"
                            label="Nom de votre structure"
                            required
                            :errors="errors"
                        />

                        <Field
                            name="organization_position"
                            v-model="account.organization_position"
                            label="Votre fonction dans cette structure"
                            required
                            :errors="errors"
                        />
                        <Field
                            name="organization_service"
                            v-model="account.organization_service"
                            label="Service / département"
                            :errors="errors"
                        />
                    </template>
                    <template v-else>
                        <Field
                            name="personal_occupation"
                            v-model="account.personal_occupation"
                            label="Profession / métier"
                            required
                            :errors="errors"
                        />
                    </template>

                    <PhoneForm v-model="account.address" :errors="errors" />
                </fieldset>

                <fieldset>
                    <legend class="mb-3">
                        <template v-if="account.is_organization">
                            Adresse de votre structure
                        </template>
                        <template v-else>
                            Adresse
                        </template>
                    </legend>
                    <AddressForm
                        v-model="account.address"
                        :errors="errors"
                        :show-phone="false"
                        @input="handleChanged"
                    />
                </fieldset>

                <slot name="append" />
            </form>
        </template>
    </div>
</template>

<script>
    import Field from "./Field.vue";
    import AddressForm from "./addresses/AddressForm.vue";
    import PhoneForm from "./addresses/PhoneForm.vue";
    import OrganizationAccountTypeRadio from "./register/steps/account-type/OrganizationAccountTypeRadio.vue";
    import PersonalAccountTypeRadio from "./register/steps/account-type/PersonalAccountTypeRadio.vue";

    export default {
        inheritAttrs: false,
        components: {
            PersonalAccountTypeRadio,
            OrganizationAccountTypeRadio,
            PhoneForm,
            AddressForm,
            Field,
        },
        props: {
            /**
             * Used in account-edit page (acacia)
             * @public
             */
            value: Object,
            errors: Object,
            forceType: Boolean,
            /**
             * @type {{full_name:string, email:string}}
             */
            user: Object,

            typeSelected: Boolean, // used acacia account
            inline: Boolean, // used acacia account
        },
        data() {
            return {
                hasSelectedAccountType: !!this.value?.id || this.forceType || this.typeSelected,
                account: {
                    is_organization: false,
                    address: {},
                    ...this.value,
                },
                valueChanged: false,
            }
        },
        watch: {
            value(value) {
                this.account = { address: {}, ...value };
                this.valueChanged = true;
            },
            account: {
                handler: 'handleChanged',
                deep: true,
            },
        },
        computed: {
            hasErrors() {
                return this.errors && Object.keys(this.errors).length > 0;
            },
            isCreation() {
                return !this.account?.id;
            },
        },
        methods: {
            handleChanged() {
                if(this.valueChanged) {
                    this.valueChanged = false;
                    return;
                }
                this.$emit('input', { ...this.account });
            },
            handleSubmitted(e) {
                this.$emit('submit', { ...this.account }, e);
            },
        },
    }
</script>
